import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { UnassignedComponent } from '@irb/irb-clients/unassigned/unassigned.component';
import { AppService } from '@irb/app.service';
import { IrbAgSearchMultipleColumnFilterComponent } from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-search-multiple-column-filter/irb-ag-search-multiple-column-filter.component';
import { IrbClientsEvents } from '../irb-clients.events';

@Injectable({
    providedIn: 'root'
})
export class UnassignedGridLayoutService implements GridLayoutService<UnassignedComponent> {
    constructor(private as: AppService) {}

    getFrameworkComponents() {
        return {
        };
    }

    getColumnDefs(parent: UnassignedComponent) {
        return [{
            headerName: 'Select All',
            headerComponent: 'customHeader',
            cellRenderer: 'customHeader',
            cellRendererParams: {parentObject: parent, type: 'rowCheckBox'},
            suppressColumnsToolPanel: true,
            suppressSizeToFit: true,
            toolPanelClass: 'toolpanel-header-checkbox-hide',
            headerComponentParams: {parentObject: parent, type: 'headerCheckBox'},
            floatingFilterComponent: 'customHeader',
            floatingFilterComponentParams: {parentObject: parent, type: 'NoClearAllBtn'},
            suppressFloatingFilterButton: true,
            pinned: 'left',
            suppressMovable: true,
            lockPosition: true,
            lockVisible: true,
            sortable: false,
            filter: true,
            resizable: false,
            minWidth: 24,
            width: 24,
            maxWidth:24,
            cellStyle: {'padding': '5px 3px 0 2px'},
            headerClass: 'customHeaderClassSelectAll',
            cellClass: 'selectAllCheckBoxRecord',
            colId: 'selectAllCheckbox'
        },
        {
            headerName: 'Account',
            field: 'accountNumber',
            sort: "asc",
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: {
                link: (params: any) => {
                    return (params.value != null && params.value.length > 0);
                },
                calltoactionTemplateFunc: parent.ENABLE_FLYOUT ? (params: any) => {
                    return parent.getTemplate(params) } : undefined,
                showHideIcon: (params: any) => parent.isUnassignActEnabled && parent.ENABLE_UNASSIGNED_ACCOUNTS && params.data.actIsVisible === false
            },
            filter: 'irbAgSearchMultipleColumnFilterComponent',
            filterParams: {
                search: (str: string, d: IrbAgSearchMultipleColumnFilterComponent) => parent.getUnassignedAccountNumber(str, d),
                threshold: 3,
                field: "accountNumber",
                enableHiddenSearchResults: true
            },
            floatingFilterComponent: 'irbInputFloatingFilterComponent',
            minWidth: 120,
            maxWidth:165,
            lockPosition: true,
            lockVisible: true
        },
        {
            headerName: 'Name',
            field: 'accountName',
            keyCreator: this.accountNameKeyCreator,
            valueFormatter: this.accountNameValueFormatter,
            cellRenderer: 'cellRendererFormatter',
            filter: 'irbAgSearchMultipleColumnFilterComponent',
            filterParams: {
                search: (str: string, d: IrbAgSearchMultipleColumnFilterComponent) => parent.getUnassignedAccountName(str, d),
                threshold: 2,
                field: "accountId",
                displayField: "name",
                enableHiddenSearchResults: true
            },
            floatingFilterComponent: 'irbInputFloatingFilterComponent',
            minWidth: 140,
            lockPosition: true,
            lockVisible: true
        },
        {
            headerName: 'Market Value',
            field: 'marketValue',
            minWidth: 80,
            maxWidth: 165,
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: {type: 'currency'},
            filter: 'irbAgNumberColumnFilterComponent',
            floatingFilterComponent: 'irbInputFloatingFilterComponent',
        },
        {
            headerName: 'Type',
            field: 'accountType',
            cellRenderer: "cellRendererFormatter",
            maxWidth: 250,
        },
        {
            headerName: 'Taxability',
            headerComponentParams: {
                irbColInfo: this.valueColInfo()
            },
            cellRenderer: "cellRendererFormatter",
            field: 'accountLocationType',
            maxWidth: 155,
        },
        {
            headerName: 'Date Opened',
            field: 'accountOpeningDate',
            maxWidth: 155,
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: {type: 'date', format:  'MM/dd/yyyy', convertWithNoDisplayETtext: true,enablePointer: true}
        },
        {
            headerName: 'Master Account',
            field: 'masterAccount',
            minWidth: 80,
            maxWidth: 180,
            filter: 'agSetColumnFilter',
            filterParams: {
                buttons: ['reset', 'apply'],
                values: (params: any) => {
                    params.success(parent.masterAccountList);
                },
                newRowsAction: 'keep',
                suppressSorting: true,
                cellHeight: 30,
                closeOnApply: true,
                refreshValuesOnOpen: true
            }
        }];
    }

    accountNameKeyCreator(params: any) {
        return params.value.value;
    }

    accountNameValueFormatter(params: any) {
        return params.value.name;
    }

    valueColInfo(){
        return `
        <p>DEFERRED<br/>
        ROTH<br/>
        TAXABLE</p>
        `
    }
}
